module.exports = __webpack_public_path__ + "images/emoji/athletic_shoe.856f2ef605ccb63deb66.png";